// removed by extract-text-webpack-plugin
module.exports = {"tableWrapper":"app-pages-Reports-Sales-ModifierSales-__ModifierSales___2NU4j","tableWrapperResponsive":"app-pages-Reports-Sales-ModifierSales-__ModifierSales___K5_qR"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/ModifierSales/ModifierSales.css
// module id = 2487
// module chunks = 0